import { Kairos } from './kairos';

export class ListadoKairos {
    kairos: Array<Kairos>;
    total: number;
    prevLink: string;
    nextLink: string;
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/intranet/models/listadoKairos.ts